module.exports = __webpack_public_path__ + "img/logo_qualiopi.453f5658.png";